// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { GroupFamily } from './group-family';
import { GroupPerson } from './group-person';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Group extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  code?: string;
  description?: string;
  name!: string;
  type?: string;
  groupFamilies!: GroupFamily[];
  groupPersons!: GroupPerson[];
}

